import React, { useEffect, useState } from 'react';
import Layout from '../components/navbar/Layout';
import TabComponent from '../components/TabComponent'; // TabComponent 경로를 수정해주세요
import DiagnosisTab1 from '../components/diagnosis/DiagnosisTab1';
import DiagnosisTab2 from '../components/diagnosis/DiagnosisTab2';
import DiagnosisTab3 from '../components/diagnosis/DiagnosisTab3';
import DiagnosisTab4 from '../components/diagnosis/DiagnosisTab4';
import UnauthorizedMessage from '../components/UnauthorizedMessage';
import { useNavigate, useLocation } from 'react-router-dom';
import { DiagnosisPageUrl } from '../url/poenUrl';
import LoginRedirect from '../components/LoginRedirect';

function DiagnosisPage() {
  const [isBuyer, setIsBuyer] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // 탭 데이터 정의
  const tabs = [
    { title: '진단 리스트', content: <DiagnosisTab1 /> },
    { title: '진단 보고서', content: <DiagnosisTab2 /> },
    { title: '진단 데이터', content: <DiagnosisTab3 /> },
    { title: '판매자 정보', content: <DiagnosisTab4 /> },
  ];

  useEffect(() => {
    const storedPermissions = localStorage.getItem('permissions');
    if (storedPermissions === 'BUYER') {
      setIsBuyer(true);
    }
  }, []);

  // activeTab 값이 URL에 있으면 해당 탭으로 이동, 없으면 첫 번째 탭으로
  const activeTabFromUrl = new URLSearchParams(location.search).get(
    'activeTab'
  );
  const initialTab = activeTabFromUrl ? parseInt(activeTabFromUrl, 10) : 0;

  const handleTabChange = (index: number) => {
    // activeTab에 따라 URL을 다르게 설정

    navigate(`${DiagnosisPageUrl}?activeTab=${index}`);
  };

  return (
    <Layout>
      <LoginRedirect />
      {isBuyer ? (
        <UnauthorizedMessage />
      ) : (
        <TabComponent
          tabs={tabs}
          activeTab={initialTab}
          onTabChange={handleTabChange} // 탭 변경 시 호출되는 함수
        />
      )}
    </Layout>
  );
}

export default DiagnosisPage;
